import { HttpService } from "./http.service";

const basePath = "/EventPeriod";
const request = HttpService.handleRequest();

export const EventPeriodService = {
  getByEventId
};

async function getByEventId(id) {
  return request.get(`${basePath}/GetByEventId/${id}`);
}

export default EventPeriodService;